import { useQuery } from '@apollo/client'
import { ListInsuranceCompanies } from '../../types'
import { LIST_INSURANCE_COMPANIES } from './operations'

export const useListInsuranceCompanies = () =>
  useQuery<ListInsuranceCompanies>(LIST_INSURANCE_COMPANIES)
